define(function(require, exports, module) {
    var ipLocArray = {
        "province": "",
        "city": "",
        "area": ""
    };
    var selector = {
        stateObj: {},
        init: function() {
            var self = this;

            self.loadStore();
            self.addEvent();
        },
        loadStore: function() {
            var self = this;
            ipLocArray = this.getIpLoc() || {
                "province": "1",
                "city": "72",
                "area": "4137"
            };

            var tag1 = null;
            var proviceId = "";
            var proviceName = "";
            var firstTabPanel = $('#store-selector div.mc[data-area="0"] ul');
            for (id in iplocation) {
                name = iplocation[id]["name"];
                if (name.length <= 4) {
                    firstTabPanel.append("<li><a data-value='" + id + "' href='#none' class='selectProvince'>" + name + "</a></li>");
                } else {
                    firstTabPanel.append("<li class='long-area'><a data-value='" + id + "' class='selectProvince' href='#none'>" + name + "</a></li>");
                }

                if (id === ipLocArray.province && tag1 == null) {
                    tag1 = "1";
                    proviceName = name;
                    proviceId = id;
                    $("#store-selector div.mt li").eq(0).find("em").text(name);
                }
            }

            var cityId = "";
            var cityName = "";

            for (i in provinceCityJson[ipLocArray.province]) {
                var cityName = provinceCityJson[ipLocArray.province][i]["name"];
                cityId = provinceCityJson[ipLocArray.province][i]["id"] + "";
                if (cityId === ipLocArray.city) {
                    $("#store-selector div.mt li").eq(1).find("em").text(cityName);
                    break;
                }
            }
            $('#store-selector [data-area="0"]').addClass("hide");

            self.stateObj.proviceName = proviceName;
            self.stateObj.cityName = cityName;

            self.setCity(proviceId, proviceName);
            self.setArea(cityId, cityName, true);
        },

        //获取ip地址对应数值
        getIpLoc: function() {
            var self = this;
            try {
                var ipLoc = self.getCookie("ipLoc-djd");

                var province = "1";
                var city = "72";
                var area = "4137";
                var firstTabPanel = $('#store-selector div.mc[data-area="0"] ul');
                if (ipLoc) {
                    var ipArray = ipLoc.split("-");
                    province = ipArray[0];
                    city = ipArray[1];
                    area = ipArray[2];
                }

                var ipLocObj = {
                    "province": province,
                    "city": city,
                    "area": area
                }
                return ipLocObj;
            } catch (error) {
                return null;
            }
        },
        addEvent: function() {
            var self = this;

            var timeout;
            $("#store-selector").hover(function() {
                var _this = this;

                timeout = setTimeout(function() {
                    $(_this).addClass("hover");
                }, 400);
            }, function() {
                clearTimeout(timeout);
                $(this).removeClass("hover");
            });

            $("#store-selector div.mt li").on("click", function() {
                var dataIdx = $(this).attr("data-idx");

                if (dataIdx == "0") {
                    $("#store-selector div.mt li").eq(0).find("em").text("请选择");
                    $("#store-selector div.mt li").eq(1).addClass("hide").find("em").text("请选择");
                    $("#store-selector div.mt li").eq(2).addClass("hide").find("em").text("请选择");
                    $(this).addClass("curr");
                    $('#store-selector [data-area="0"]').removeClass("hide");
                    $('#store-selector [data-area="1"]').addClass("hide");
                    $('#store-selector [data-area="2"]').addClass("hide");
                } else if (dataIdx == "1") {
                    $("#store-selector div.mt li").eq(0).removeClass("curr");
                    $("#store-selector div.mt li").eq(1).addClass("curr").find("em").text("请选择");
                    $("#store-selector div.mt li").eq(2).addClass("hide").find("em").text("请选择");
                    $('#store-selector [data-area="1"]').removeClass("hide");
                    $('#store-selector [data-area="2"]').addClass("hide");
                }
            });

            $(".JD-stock .mc").delegate(".selectProvince", "click", function() {
                var id = $(this).attr("data-value");
                var name = $(this).text();
                self.setCity(id, name);
            });

            $(".JD-stock .mc").delegate(".selectCity", "click", function() {
                var name = $(this).text();
                var id = $(this).attr("data-value");

                self.setArea(id, name);
            });

            $(".JD-stock .mc").delegate(".selectArea", "click", function() {
                var id = $(this).attr("data-value");
                var name = $(this).text();
                ipLocArray.area = id;
                var iplocStr = ipLocArray.province + "-" + ipLocArray.city + "-" + ipLocArray.area + "-" + "0-";

                var day = 30;
                var date = new Date;
                date.setTime(date.getTime() + 24 * day * 60 * 60 * 1000);
                document.cookie = "ipLoc-djd" + "=" + escape(iplocStr) + ";expires=" + date.toGMTString() + ";path=/;domain=." + pageConfig.FN_getDomain();

                // location.reload();
                location.href = location.href.replace(/#none/g, "");
            });
        },
        setCity: function(id, name) {
            $("#store-selector div.mt li").eq(0).removeClass("curr");
            $("#store-selector div.mt li").eq(0).find("em").text(name);
            $("#store-selector div.mt li").eq(1).removeClass("hide").addClass("curr");
            $('#store-selector [data-area="0"]').addClass("hide");
            $('#store-selector [data-area="1"]').removeClass("hide");
            $('#store-selector [data-area="1"] p.ac').addClass("hide");
            $('#store-selector div.mc[data-area="1"] ul').empty();
            $('#store-selector div.mc[data-area="2"] ul').empty();
            $('#store-selector [data-area="2"] p.ac').removeClass("hide");

            var provinceCity = provinceCityJson[id];
            var str1 = "";
            var str2 = "";
            var str3 = "";
            for (var i = 0; i < provinceCity.length; i++) {
                var cityName = provinceCity[i]["name"];
                var cityId = provinceCity[i]["id"];
                if (cityName.length < 5) {
                    str1 += '<li><a data-value="' + cityId + '" href="#none" class="selectCity">' + cityName + '</li>';
                } else {
                    if (cityName.length <= 11) {
                        str2 += '<li class="long-area"><a data-value="' + cityId + '" href="#none" class="selectCity">' + cityName + '</a></li>';
                    } else {
                        str3 += '<li class="longer-area"><a data-value="' + cityId + '" href="#none" class="selectCity">' + cityName + '</a></li>';
                    }
                }
            }
            $('#store-selector div.mc[data-area="1"] ul').append(str1 + str2 + str3);

            ipLocArray.province = id;
        },

        //选完地区之后，发送了个请求，返回了地区名字，添加到了html中
        setArea: function(id, name, firstLoad) {
            var self = this;

            $("#store-selector div.mt li").eq(1).removeClass("curr");
            $("#store-selector div.mt li").eq(1).find("em").text(name);
            $("#store-selector div.mt li").eq(2).removeClass("hide").addClass("curr");
            $.ajax({
                url: "//d.jd.com/area/get?fid=" + id,
                dataType: "jsonp",
                success: function(data) {
                    self.getAreaList_callback(data, firstLoad);
                    ipLocArray.city = id;
                }
            })
        },
        getAreaList_callback: function(data, firstLoad) {
            var self = this;

            var areaId = "";
            if (firstLoad) {
                var ipLoc = self.getIpLoc();
                if (ipLoc != null) {
                    areaId = ipLoc.area;
                }
            }
            $('#store-selector div[data-area="1"]').addClass("hide");
            $('#store-selector div[data-area="2"]').removeClass("hide");
            $('#store-selector div[data-area="2"] p.ac').addClass("hide");
            $('#store-selector div.mc[data-area="2"] ul').empty();
            var areaObj, name;
            var str1 = "";
            var str2 = "";
            var str3 = "";
            for (var i = 0; i < data.length; i++) {
                areaObj = data[i];
                name = areaObj.name;
                if (name.length < 5) {
                    str1 += "<li><a data-value='" + areaObj["id"] + "' href='#none' class='selectArea'>" + areaObj["name"] + "</a></li>";
                } else {
                    if (name.length <= 11) {
                        str2 += "<li class='long-area'><a data-value='" + areaObj["id"] + "' href='#none' class='selectArea'>" + areaObj["name"] + "</a></li>";
                    } else {
                        str3 += "<li class='longer-area'><a data-value='" + areaObj["id"] + "' href='#none' class='selectArea'>" + areaObj["name"] + "</a></li>";
                    }
                }

                if (areaId != "" && data[i].id.toString() == areaId) {
                    var name = data[i].name;
                    self.stateObj.areaName = name;
                    $("#store-selector div.mt li").eq(0).removeClass("curr");
                    $("#store-selector div.mt li").eq(1).removeClass("curr");
                    $("#store-selector div.mt li").eq(2).find("em").text(name);
                    $("#store-selector div.mt li").eq(2).removeClass("hide").addClass("curr");

                    $("#store-selector div.text").html(self.stateObj.proviceName + self.stateObj.cityName + self.stateObj.areaName + "<b></b>");
                }
            }
            $('#store-selector div.mc[data-area="2"] ul').append(str1 + str2 + str3);
        },
        getCookie: function(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length)
                }
                if (c.indexOf(nameEQ) == 0) {
                    return c.substring(nameEQ.length, c.length)
                }
            }
            return null
        }
    };

    var iplocation = {
            1: {
                name: "北京",
                root: 0,
                djd: 1,
                c: 72
            },
            2: {
                name: "上海",
                root: 1,
                djd: 1,
                c: 78
            },
            3: {
                name: "天津",
                root: 0,
                djd: 1,
                c: 51035
            },
            4: {
                name: "重庆",
                root: 3,
                djd: 1,
                c: 113
            },
            5: {
                name: "河北",
                root: 0,
                djd: 1,
                c: 142
            },
            6: {
                name: "山西",
                root: 0,
                djd: 1,
                c: 303
            },
            7: {
                name: "河南",
                root: 0,
                djd: 1,
                c: 412
            },
            8: {
                name: "辽宁",
                root: 0,
                djd: 1,
                c: 560
            },
            9: {
                name: "吉林",
                root: 0,
                djd: 1,
                c: 639
            },
            10: {
                name: "黑龙江",
                root: 0,
                djd: 1,
                c: 698
            },
            11: {
                name: "内蒙古",
                root: 0,
                djd: 0,
                c: 799
            },
            12: {
                name: "江苏",
                root: 1,
                djd: 1,
                c: 904
            },
            13: {
                name: "山东",
                root: 0,
                djd: 1,
                c: 1e3
            },
            14: {
                name: "安徽",
                root: 1,
                djd: 1,
                c: 1116
            },
            15: {
                name: "浙江",
                root: 1,
                djd: 1,
                c: 1158
            },
            16: {
                name: "福建",
                root: 2,
                djd: 1,
                c: 1303
            },
            17: {
                name: "湖北",
                root: 0,
                djd: 1,
                c: 1381
            },
            18: {
                name: "湖南",
                root: 2,
                djd: 1,
                c: 1482
            },
            19: {
                name: "广东",
                root: 2,
                djd: 1,
                c: 1601
            },
            20: {
                name: "广西",
                root: 2,
                djd: 1,
                c: 1715
            },
            21: {
                name: "江西",
                root: 2,
                djd: 1,
                c: 1827
            },
            22: {
                name: "四川",
                root: 3,
                djd: 1,
                c: 1930
            },
            23: {
                name: "海南",
                root: 2,
                djd: 1,
                c: 2121
            },
            24: {
                name: "贵州",
                root: 3,
                djd: 1,
                c: 2144
            },
            25: {
                name: "云南",
                root: 3,
                djd: 1,
                c: 2235
            },
            26: {
                name: "西藏",
                root: 3,
                djd: 0,
                c: 2951
            },
            27: {
                name: "陕西",
                root: 3,
                djd: 1,
                c: 2376
            },
            28: {
                name: "甘肃",
                root: 3,
                djd: 1,
                c: 2487
            },
            29: {
                name: "青海",
                root: 3,
                djd: 0,
                c: 2580
            },
            30: {
                name: "宁夏",
                root: 3,
                djd: 1,
                c: 2628
            },
            31: {
                name: "新疆",
                root: 3,
                djd: 0,
                c: 2652
            },
            32: {
                name: "台湾",
                root: 2,
                djd: 0,
                c: 2768
            },
            42: {
                name: "香港",
                root: 2,
                djd: 0,
                c: 2754
            },
            43: {
                name: "澳门",
                root: 2,
                djd: 0,
                c: 2770
            },
            84: {
                name: "钓鱼岛",
                root: 2,
                djd: 0,
                c: 84
            }
        },
        provinceCityJson = {
            1: [{
                id: 72,
                name: "朝阳区"
            }, {
                id: 2800,
                name: "海淀区"
            }, {
                id: 2801,
                name: "西城区"
            }, {
                id: 2802,
                name: "东城区"
            }, {
                id: 2803,
                name: "崇文区"
            }, {
                id: 2804,
                name: "宣武区"
            }, {
                id: 2805,
                name: "丰台区"
            }, {
                id: 2806,
                name: "石景山区"
            }, {
                id: 2807,
                name: "门头沟"
            }, {
                id: 2808,
                name: "房山区"
            }, {
                id: 2809,
                name: "通州区"
            }, {
                id: 2810,
                name: "大兴区"
            }, {
                id: 2812,
                name: "顺义区"
            }, {
                id: 2814,
                name: "怀柔区"
            }, {
                id: 2816,
                name: "密云区"
            }, {
                id: 2901,
                name: "昌平区"
            }, {
                id: 2953,
                name: "平谷区"
            }, {
                id: 3065,
                name: "延庆县"
            }],
            2: [{
                id: 2813,
                name: "徐汇区"
            }, {
                id: 2815,
                name: "长宁区"
            }, {
                id: 2817,
                name: "静安区"
            }, {
                id: 2820,
                name: "闸北区"
            }, {
                id: 2822,
                name: "虹口区"
            }, {
                id: 2823,
                name: "杨浦区"
            }, {
                id: 2824,
                name: "宝山区"
            }, {
                id: 2825,
                name: "闵行区"
            }, {
                id: 2826,
                name: "嘉定区"
            }, {
                id: 2830,
                name: "浦东新区"
            }, {
                id: 2833,
                name: "青浦区"
            }, {
                id: 2834,
                name: "松江区"
            }, {
                id: 2835,
                name: "金山区"
            }, {
                id: 2836,
                name: "南汇区"
            }, {
                id: 2837,
                name: "奉贤区"
            }, {
                id: 2841,
                name: "普陀区"
            }, {
                id: 2919,
                name: "崇明县"
            }, {
                id: 78,
                name: "黄浦区"
            }],
            3: [{
                id: 51035,
                name: "东丽区"
            }, {
                id: 51036,
                name: "和平区"
            }, {
                id: 51037,
                name: "河北区"
            }, {
                id: 51038,
                name: "河东区"
            }, {
                id: 51039,
                name: "河西区"
            }, {
                id: 51040,
                name: "红桥区"
            }, {
                id: 51041,
                name: "蓟县"
            }, {
                id: 51042,
                name: "静海县"
            }, {
                id: 51043,
                name: "南开区"
            }, {
                id: 51044,
                name: "塘沽区"
            }, {
                id: 51045,
                name: "西青区"
            }, {
                id: 51046,
                name: "武清区"
            }, {
                id: 51047,
                name: "津南区"
            }, {
                id: 51048,
                name: "汉沽区"
            }, {
                id: 51049,
                name: "大港区"
            }, {
                id: 51050,
                name: "北辰区"
            }, {
                id: 51051,
                name: "宝坻区"
            }, {
                id: 51052,
                name: "宁河县"
            }],
            4: [{
                id: 113,
                name: "万州区"
            }, {
                id: 114,
                name: "涪陵区"
            }, {
                id: 115,
                name: "梁平县"
            }, {
                id: 119,
                name: "南川区"
            }, {
                id: 123,
                name: "潼南县"
            }, {
                id: 126,
                name: "大足区"
            }, {
                id: 128,
                name: "黔江区"
            }, {
                id: 129,
                name: "武隆县"
            }, {
                id: 130,
                name: "丰都县"
            }, {
                id: 131,
                name: "奉节县"
            }, {
                id: 132,
                name: "开县"
            }, {
                id: 133,
                name: "云阳县"
            }, {
                id: 134,
                name: "忠县"
            }, {
                id: 135,
                name: "巫溪县"
            }, {
                id: 136,
                name: "巫山县"
            }, {
                id: 137,
                name: "石柱县"
            }, {
                id: 138,
                name: "彭水县"
            }, {
                id: 139,
                name: "垫江县"
            }, {
                id: 140,
                name: "酉阳县"
            }, {
                id: 141,
                name: "秀山县"
            }, {
                id: 48131,
                name: "璧山县"
            }, {
                id: 48132,
                name: "荣昌县"
            }, {
                id: 48133,
                name: "铜梁县"
            }, {
                id: 48201,
                name: "合川区"
            }, {
                id: 48202,
                name: "巴南区"
            }, {
                id: 48203,
                name: "北碚区"
            }, {
                id: 48204,
                name: "江津区"
            }, {
                id: 48205,
                name: "渝北区"
            }, {
                id: 48206,
                name: "长寿区"
            }, {
                id: 48207,
                name: "永川区"
            }, {
                id: 50950,
                name: "江北区"
            }, {
                id: 50951,
                name: "南岸区"
            }, {
                id: 50952,
                name: "九龙坡区"
            }, {
                id: 50953,
                name: "沙坪坝区"
            }, {
                id: 50954,
                name: "大渡口区"
            }, {
                id: 50995,
                name: "綦江区"
            }, {
                id: 51026,
                name: "渝中区"
            }, {
                id: 51027,
                name: "高新区"
            }, {
                id: 51028,
                name: "北部新区"
            }, {
                id: 4164,
                name: "城口县"
            }, {
                id: 3076,
                name: "高新区"
            }],
            5: [{
                id: 142,
                name: "石家庄市"
            }, {
                id: 148,
                name: "邯郸市"
            }, {
                id: 164,
                name: "邢台市"
            }, {
                id: 199,
                name: "保定市"
            }, {
                id: 224,
                name: "张家口市"
            }, {
                id: 239,
                name: "承德市"
            }, {
                id: 248,
                name: "秦皇岛市"
            }, {
                id: 258,
                name: "唐山市"
            }, {
                id: 264,
                name: "沧州市"
            }, {
                id: 274,
                name: "廊坊市"
            }, {
                id: 275,
                name: "衡水市"
            }],
            6: [{
                id: 303,
                name: "太原市"
            }, {
                id: 309,
                name: "大同市"
            }, {
                id: 318,
                name: "阳泉市"
            }, {
                id: 325,
                name: "晋城市"
            }, {
                id: 330,
                name: "朔州市"
            }, {
                id: 336,
                name: "晋中市"
            }, {
                id: 350,
                name: "忻州市"
            }, {
                id: 368,
                name: "吕梁市"
            }, {
                id: 379,
                name: "临汾市"
            }, {
                id: 398,
                name: "运城市"
            }, {
                id: 3074,
                name: "长治市"
            }],
            7: [{
                id: 412,
                name: "郑州市"
            }, {
                id: 420,
                name: "开封市"
            }, {
                id: 427,
                name: "洛阳市"
            }, {
                id: 438,
                name: "平顶山市"
            }, {
                id: 446,
                name: "焦作市"
            }, {
                id: 454,
                name: "鹤壁市"
            }, {
                id: 458,
                name: "新乡市"
            }, {
                id: 468,
                name: "安阳市"
            }, {
                id: 475,
                name: "濮阳市"
            }, {
                id: 482,
                name: "许昌市"
            }, {
                id: 489,
                name: "漯河市"
            }, {
                id: 495,
                name: "三门峡市"
            }, {
                id: 502,
                name: "南阳市"
            }, {
                id: 517,
                name: "商丘市"
            }, {
                id: 527,
                name: "周口市"
            }, {
                id: 538,
                name: "驻马店市"
            }, {
                id: 549,
                name: "信阳市"
            }, {
                id: 2780,
                name: "济源市"
            }],
            8: [{
                id: 560,
                name: "沈阳市"
            }, {
                id: 573,
                name: "大连市"
            }, {
                id: 579,
                name: "鞍山市"
            }, {
                id: 584,
                name: "抚顺市"
            }, {
                id: 589,
                name: "本溪市"
            }, {
                id: 593,
                name: "丹东市"
            }, {
                id: 598,
                name: "锦州市"
            }, {
                id: 604,
                name: "葫芦岛市"
            }, {
                id: 609,
                name: "营口市"
            }, {
                id: 613,
                name: "盘锦市"
            }, {
                id: 617,
                name: "阜新市"
            }, {
                id: 621,
                name: "辽阳市"
            }, {
                id: 632,
                name: "朝阳市"
            }, {
                id: 6858,
                name: "铁岭市"
            }],
            9: [{
                id: 639,
                name: "长春市"
            }, {
                id: 644,
                name: "吉林市"
            }, {
                id: 651,
                name: "四平市"
            }, {
                id: 2992,
                name: "辽源市"
            }, {
                id: 657,
                name: "通化市"
            }, {
                id: 664,
                name: "白山市"
            }, {
                id: 674,
                name: "松原市"
            }, {
                id: 681,
                name: "白城市"
            }, {
                id: 687,
                name: "延边州"
            }],
            10: [{
                id: 727,
                name: "鹤岗市"
            }, {
                id: 731,
                name: "双鸭山市"
            }, {
                id: 737,
                name: "鸡西市"
            }, {
                id: 742,
                name: "大庆市"
            }, {
                id: 753,
                name: "伊春市"
            }, {
                id: 757,
                name: "牡丹江市"
            }, {
                id: 765,
                name: "佳木斯市"
            }, {
                id: 773,
                name: "七台河市"
            }, {
                id: 776,
                name: "黑河市"
            }, {
                id: 782,
                name: "绥化市"
            }, {
                id: 793,
                name: "大兴安岭地区"
            }, {
                id: 698,
                name: "哈尔滨市"
            }, {
                id: 712,
                name: "齐齐哈尔市"
            }],
            11: [{
                id: 799,
                name: "呼和浩特市"
            }, {
                id: 805,
                name: "包头市"
            }, {
                id: 810,
                name: "乌海市"
            }, {
                id: 812,
                name: "赤峰市"
            }, {
                id: 823,
                name: "乌兰察布市"
            }, {
                id: 835,
                name: "锡林郭勒盟"
            }, {
                id: 848,
                name: "呼伦贝尔市"
            }, {
                id: 870,
                name: "鄂尔多斯市"
            }, {
                id: 880,
                name: "巴彦淖尔市"
            }, {
                id: 891,
                name: "阿拉善盟"
            }, {
                id: 895,
                name: "兴安盟"
            }, {
                id: 902,
                name: "通辽市"
            }],
            12: [{
                id: 904,
                name: "南京市"
            }, {
                id: 911,
                name: "徐州市"
            }, {
                id: 919,
                name: "连云港市"
            }, {
                id: 925,
                name: "淮安市"
            }, {
                id: 933,
                name: "宿迁市"
            }, {
                id: 939,
                name: "盐城市"
            }, {
                id: 951,
                name: "扬州市"
            }, {
                id: 959,
                name: "泰州市"
            }, {
                id: 965,
                name: "南通市"
            }, {
                id: 972,
                name: "镇江市"
            }, {
                id: 978,
                name: "常州市"
            }, {
                id: 984,
                name: "无锡市"
            }, {
                id: 988,
                name: "苏州市"
            }],
            13: [{
                id: 2900,
                name: "济宁市"
            }, {
                id: 1e3,
                name: "济南市"
            }, {
                id: 1007,
                name: "青岛市"
            }, {
                id: 1016,
                name: "淄博市"
            }, {
                id: 1022,
                name: "枣庄市"
            }, {
                id: 1025,
                name: "东营市"
            }, {
                id: 1032,
                name: "潍坊市"
            }, {
                id: 1042,
                name: "烟台市"
            }, {
                id: 1053,
                name: "威海市"
            }, {
                id: 1058,
                name: "莱芜市"
            }, {
                id: 1060,
                name: "德州市"
            }, {
                id: 1072,
                name: "临沂市"
            }, {
                id: 1081,
                name: "聊城市"
            }, {
                id: 1090,
                name: "滨州市"
            }, {
                id: 1099,
                name: "菏泽市"
            }, {
                id: 1108,
                name: "日照市"
            }, {
                id: 1112,
                name: "泰安市"
            }],
            14: [{
                id: 1151,
                name: "黄山市"
            }, {
                id: 1159,
                name: "滁州市"
            }, {
                id: 1167,
                name: "阜阳市"
            }, {
                id: 1174,
                name: "亳州市"
            }, {
                id: 1180,
                name: "宿州市"
            }, {
                id: 1201,
                name: "池州市"
            }, {
                id: 1206,
                name: "六安市"
            }, {
                id: 2971,
                name: "宣城市"
            }, {
                id: 1114,
                name: "铜陵市"
            }, {
                id: 1116,
                name: "合肥市"
            }, {
                id: 1121,
                name: "淮南市"
            }, {
                id: 1124,
                name: "淮北市"
            }, {
                id: 1127,
                name: "芜湖市"
            }, {
                id: 1132,
                name: "蚌埠市"
            }, {
                id: 1137,
                name: "马鞍山市"
            }, {
                id: 1140,
                name: "安庆市"
            }],
            15: [{
                id: 1158,
                name: "宁波市"
            }, {
                id: 1273,
                name: "衢州市"
            }, {
                id: 1280,
                name: "丽水市"
            }, {
                id: 1290,
                name: "台州市"
            }, {
                id: 1298,
                name: "舟山市"
            }, {
                id: 1213,
                name: "杭州市"
            }, {
                id: 1233,
                name: "温州市"
            }, {
                id: 1243,
                name: "嘉兴市"
            }, {
                id: 1250,
                name: "湖州市"
            }, {
                id: 1255,
                name: "绍兴市"
            }, {
                id: 1262,
                name: "金华市"
            }],
            16: [{
                id: 1303,
                name: "福州市"
            }, {
                id: 1315,
                name: "厦门市"
            }, {
                id: 1317,
                name: "三明市"
            }, {
                id: 1329,
                name: "莆田市"
            }, {
                id: 1332,
                name: "泉州市"
            }, {
                id: 1341,
                name: "漳州市"
            }, {
                id: 1352,
                name: "南平市"
            }, {
                id: 1362,
                name: "龙岩市"
            }, {
                id: 1370,
                name: "宁德市"
            }],
            17: [{
                id: 1432,
                name: "孝感市"
            }, {
                id: 1441,
                name: "黄冈市"
            }, {
                id: 1458,
                name: "咸宁市"
            }, {
                id: 1466,
                name: "恩施州"
            }, {
                id: 1475,
                name: "鄂州市"
            }, {
                id: 1477,
                name: "荆门市"
            }, {
                id: 1479,
                name: "随州市"
            }, {
                id: 3154,
                name: "神农架林区"
            }, {
                id: 1381,
                name: "武汉市"
            }, {
                id: 1387,
                name: "黄石市"
            }, {
                id: 1396,
                name: "襄阳市"
            }, {
                id: 1405,
                name: "十堰市"
            }, {
                id: 1413,
                name: "荆州市"
            }, {
                id: 1421,
                name: "宜昌市"
            }, {
                id: 2922,
                name: "潜江市"
            }, {
                id: 2980,
                name: "天门市"
            }, {
                id: 2983,
                name: "仙桃市"
            }],
            18: [{
                id: 4250,
                name: "耒阳市"
            }, {
                id: 1482,
                name: "长沙市"
            }, {
                id: 1488,
                name: "株洲市"
            }, {
                id: 1495,
                name: "湘潭市"
            }, {
                id: 1499,
                name: "韶山市"
            }, {
                id: 1501,
                name: "衡阳市"
            }, {
                id: 1511,
                name: "邵阳市"
            }, {
                id: 1522,
                name: "岳阳市"
            }, {
                id: 1530,
                name: "常德市"
            }, {
                id: 1540,
                name: "张家界市"
            }, {
                id: 1544,
                name: "郴州市"
            }, {
                id: 1555,
                name: "益阳市"
            }, {
                id: 1560,
                name: "永州市"
            }, {
                id: 1574,
                name: "怀化市"
            }, {
                id: 1586,
                name: "娄底市"
            }, {
                id: 1592,
                name: "湘西州"
            }],
            19: [{
                id: 1601,
                name: "广州市"
            }, {
                id: 1607,
                name: "深圳市"
            }, {
                id: 1609,
                name: "珠海市"
            }, {
                id: 1611,
                name: "汕头市"
            }, {
                id: 1617,
                name: "韶关市"
            }, {
                id: 1627,
                name: "河源市"
            }, {
                id: 1634,
                name: "梅州市"
            }, {
                id: 1709,
                name: "揭阳市"
            }, {
                id: 1643,
                name: "惠州市"
            }, {
                id: 1650,
                name: "汕尾市"
            }, {
                id: 1655,
                name: "东莞市"
            }, {
                id: 1657,
                name: "中山市"
            }, {
                id: 1659,
                name: "江门市"
            }, {
                id: 1666,
                name: "佛山市"
            }, {
                id: 1672,
                name: "阳江市"
            }, {
                id: 1677,
                name: "湛江市"
            }, {
                id: 1684,
                name: "茂名市"
            }, {
                id: 1690,
                name: "肇庆市"
            }, {
                id: 1698,
                name: "云浮市"
            }, {
                id: 1704,
                name: "清远市"
            }, {
                id: 1705,
                name: "潮州市"
            }],
            20: [{
                id: 3168,
                name: "崇左市"
            }, {
                id: 1715,
                name: "南宁市"
            }, {
                id: 1720,
                name: "柳州市"
            }, {
                id: 1726,
                name: "桂林市"
            }, {
                id: 1740,
                name: "梧州市"
            }, {
                id: 1746,
                name: "北海市"
            }, {
                id: 1749,
                name: "防城港市"
            }, {
                id: 1753,
                name: "钦州市"
            }, {
                id: 1757,
                name: "贵港市"
            }, {
                id: 1761,
                name: "玉林市"
            }, {
                id: 1792,
                name: "贺州市"
            }, {
                id: 1806,
                name: "百色市"
            }, {
                id: 1818,
                name: "河池市"
            }, {
                id: 3044,
                name: "来宾市"
            }],
            21: [{
                id: 1827,
                name: "南昌市"
            }, {
                id: 1832,
                name: "景德镇市"
            }, {
                id: 1836,
                name: "萍乡市"
            }, {
                id: 1842,
                name: "新余市"
            }, {
                id: 1845,
                name: "九江市"
            }, {
                id: 1857,
                name: "鹰潭市"
            }, {
                id: 1861,
                name: "上饶市"
            }, {
                id: 1874,
                name: "宜春市"
            }, {
                id: 1885,
                name: "抚州市"
            }, {
                id: 1898,
                name: "吉安市"
            }, {
                id: 1911,
                name: "赣州市"
            }],
            22: [{
                id: 2103,
                name: "凉山州"
            }, {
                id: 1930,
                name: "成都市"
            }, {
                id: 1946,
                name: "自贡市"
            }, {
                id: 1950,
                name: "攀枝花市"
            }, {
                id: 1954,
                name: "泸州市"
            }, {
                id: 1960,
                name: "绵阳市"
            }, {
                id: 1962,
                name: "德阳市"
            }, {
                id: 1977,
                name: "广元市"
            }, {
                id: 1983,
                name: "遂宁市"
            }, {
                id: 1988,
                name: "内江市"
            }, {
                id: 1993,
                name: "乐山市"
            }, {
                id: 2005,
                name: "宜宾市"
            }, {
                id: 2016,
                name: "广安市"
            }, {
                id: 2022,
                name: "南充市"
            }, {
                id: 2033,
                name: "达州市"
            }, {
                id: 2042,
                name: "巴中市"
            }, {
                id: 2047,
                name: "雅安市"
            }, {
                id: 2058,
                name: "眉山市"
            }, {
                id: 2065,
                name: "资阳市"
            }, {
                id: 2070,
                name: "阿坝州"
            }, {
                id: 2084,
                name: "甘孜州"
            }],
            23: [{
                id: 3690,
                name: "三亚市"
            }, {
                id: 3698,
                name: "文昌市"
            }, {
                id: 3699,
                name: "五指山市"
            }, {
                id: 3701,
                name: "临高县"
            }, {
                id: 3702,
                name: "澄迈县"
            }, {
                id: 3703,
                name: "定安县"
            }, {
                id: 3704,
                name: "屯昌县"
            }, {
                id: 3705,
                name: "昌江县"
            }, {
                id: 3706,
                name: "白沙县"
            }, {
                id: 3707,
                name: "琼中县"
            }, {
                id: 3708,
                name: "陵水县"
            }, {
                id: 3709,
                name: "保亭县"
            }, {
                id: 3710,
                name: "乐东县"
            }, {
                id: 3711,
                name: "三沙市"
            }, {
                id: 2121,
                name: "海口市"
            }, {
                id: 3115,
                name: "琼海市"
            }, {
                id: 3137,
                name: "万宁市"
            }, {
                id: 3173,
                name: "东方市"
            }, {
                id: 3034,
                name: "儋州市"
            }],
            24: [{
                id: 2144,
                name: "贵阳市"
            }, {
                id: 2150,
                name: "六盘水市"
            }, {
                id: 2155,
                name: "遵义市"
            }, {
                id: 2169,
                name: "铜仁市"
            }, {
                id: 2180,
                name: "毕节市"
            }, {
                id: 2189,
                name: "安顺市"
            }, {
                id: 2196,
                name: "黔西南州"
            }, {
                id: 2205,
                name: "黔东南州"
            }, {
                id: 2222,
                name: "黔南州"
            }],
            25: [{
                id: 4108,
                name: "迪庆州"
            }, {
                id: 2235,
                name: "昆明市"
            }, {
                id: 2247,
                name: "曲靖市"
            }, {
                id: 2258,
                name: "玉溪市"
            }, {
                id: 2270,
                name: "昭通市"
            }, {
                id: 2281,
                name: "普洱市"
            }, {
                id: 2291,
                name: "临沧市"
            }, {
                id: 2298,
                name: "保山市"
            }, {
                id: 2304,
                name: "丽江市"
            }, {
                id: 2309,
                name: "文山州"
            }, {
                id: 2318,
                name: "红河州"
            }, {
                id: 2332,
                name: "西双版纳州"
            }, {
                id: 2336,
                name: "楚雄州"
            }, {
                id: 2347,
                name: "大理州"
            }, {
                id: 2360,
                name: "德宏州"
            }, {
                id: 2366,
                name: "怒江州"
            }],
            26: [{
                id: 3970,
                name: "阿里地区"
            }, {
                id: 3971,
                name: "林芝地区"
            }, {
                id: 2951,
                name: "拉萨市"
            }, {
                id: 3107,
                name: "那曲地区"
            }, {
                id: 3129,
                name: "山南地区"
            }, {
                id: 3138,
                name: "昌都地区"
            }, {
                id: 3144,
                name: "日喀则地区"
            }],
            27: [{
                id: 2428,
                name: "延安市"
            }, {
                id: 2442,
                name: "汉中市"
            }, {
                id: 2454,
                name: "榆林市"
            }, {
                id: 2468,
                name: "商洛市"
            }, {
                id: 2476,
                name: "安康市"
            }, {
                id: 2376,
                name: "西安市"
            }, {
                id: 2386,
                name: "铜川市"
            }, {
                id: 2390,
                name: "宝鸡市"
            }, {
                id: 2402,
                name: "咸阳市"
            }, {
                id: 2416,
                name: "渭南市"
            }],
            28: [{
                id: 2525,
                name: "庆阳市"
            }, {
                id: 2534,
                name: "陇南市"
            }, {
                id: 2544,
                name: "武威市"
            }, {
                id: 2549,
                name: "张掖市"
            }, {
                id: 2556,
                name: "酒泉市"
            }, {
                id: 2564,
                name: "甘南州"
            }, {
                id: 2573,
                name: "临夏州"
            }, {
                id: 3080,
                name: "定西市"
            }, {
                id: 2487,
                name: "兰州市"
            }, {
                id: 2492,
                name: "金昌市"
            }, {
                id: 2495,
                name: "白银市"
            }, {
                id: 2501,
                name: "天水市"
            }, {
                id: 2509,
                name: "嘉峪关市"
            }, {
                id: 2518,
                name: "平凉市"
            }],
            29: [{
                id: 2580,
                name: "西宁市"
            }, {
                id: 2585,
                name: "海东地区"
            }, {
                id: 2592,
                name: "海北州"
            }, {
                id: 2597,
                name: "黄南州"
            }, {
                id: 2603,
                name: "海南州"
            }, {
                id: 2605,
                name: "果洛州"
            }, {
                id: 2612,
                name: "玉树州"
            }, {
                id: 2620,
                name: "海西州"
            }],
            30: [{
                id: 2628,
                name: "银川市"
            }, {
                id: 2632,
                name: "石嘴山市"
            }, {
                id: 2637,
                name: "吴忠市"
            }, {
                id: 2644,
                name: "固原市"
            }, {
                id: 3071,
                name: "中卫市"
            }],
            31: [{
                id: 4110,
                name: "五家渠市"
            }, {
                id: 4163,
                name: "博尔塔拉蒙古自治州阿拉山口口岸"
            }, {
                id: 15945,
                name: "阿拉尔市"
            }, {
                id: 15946,
                name: "图木舒克市"
            }, {
                id: 2652,
                name: "乌鲁木齐市"
            }, {
                id: 2654,
                name: "克拉玛依市"
            }, {
                id: 2656,
                name: "石河子市"
            }, {
                id: 2658,
                name: "吐鲁番地区"
            }, {
                id: 2662,
                name: "哈密地区"
            }, {
                id: 2666,
                name: "和田地区"
            }, {
                id: 2675,
                name: "阿克苏地区"
            }, {
                id: 2686,
                name: "喀什地区"
            }, {
                id: 2699,
                name: "克孜勒苏州"
            }, {
                id: 2704,
                name: "巴音郭楞州"
            }, {
                id: 2714,
                name: "昌吉州"
            }, {
                id: 2723,
                name: "博尔塔拉州"
            }, {
                id: 2727,
                name: "伊犁州"
            }, {
                id: 2736,
                name: "塔城地区"
            }, {
                id: 2744,
                name: "阿勒泰地区"
            }],
            32: [{
                id: 2768,
                name: "台湾市"
            }],
            42: [{
                id: 2754,
                name: "香港特别行政区"
            }],
            43: [{
                id: 2770,
                name: "澳门市"
            }],
            84: [{
                id: 1310,
                name: "钓鱼岛"
            }]
        }

    module.exports = selector;
});



// WEBPACK FOOTER //
// ./src/js/unit/storeSelector/storeSelector.js